/* ajax get util */
import axios from 'axios';

export default {
  get: function (url, callbackSuccess, callbackError) {

    axios.get(url)
      .then(function (response) {
        try {

          //if response.data, lets sort on is_featured
            if (response.data && response.data.list) {
                response.data.list.sort((a, b) => {
                if (a.is_featured && !b.is_featured) {
                    return -1;
                } else if (!a.is_featured && b.is_featured) {
                    return 1;
                } else {
                    return 0;
                }
                });
            }


          return callbackSuccess(JSON.parse(response.data));
        } catch (e) {
          if (e instanceof SyntaxError) {
            return callbackSuccess(response.data);
          }
        }
        //console.log(`Invalid response from url: ${url}`, response);
      })
      .catch(function (error) {
        callbackError = callbackError || function (error) {
          console.log(`Error getting json from url: ${url}`, error);
        };
        callbackError(error);
      });
  },
};